/**
 * One-time announcement for the set of the day. Shows once per account on
 * the first open after it ships, on web and in the app, and never again
 * after either button. The dismissal is stored on the account so a
 * second device doesn't show it twice, with localStorage as the fast path.
 */
import React, { useEffect, useState } from "react";
import { Flame, X } from "lucide-react";
import { GOLD } from "../constants/theme";
import { loadUserData, saveUserData } from "../utils/userData";

const KEY = "seen_sets_launch";
const LS = "bam_seen_sets_launch";

export function SetsLaunchModal({ C, ready, go }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!ready) return undefined;
    let alive = true;
    try { if (localStorage.getItem(LS) === "1") return undefined; } catch {}
    loadUserData(KEY, null).then(v => { if (alive && !v?.at) setShow(true); }).catch(() => {});
    return () => { alive = false; };
  }, [ready]);
  if (!show) return null;
  const dismiss = (open) => {
    setShow(false);
    try { localStorage.setItem(LS, "1"); } catch {}
    saveUserData(KEY, { at: new Date().toISOString() }).catch(() => {});
    if (open) go?.("playbook");
  };
  return (
    <div onClick={() => dismiss(false)} style={{ position: "fixed", inset: 0, zIndex: 5800, background: "rgba(0,0,0,0.72)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} className="film-fade"
        style={{ width: "100%", maxWidth: 460, background: "linear-gradient(180deg, #141414, #0A0A0A)", border: `1px solid ${GOLD}55`, borderRadius: 18, padding: "26px 26px 22px", color: "#F5F5F5", fontFamily: "'DM Sans', sans-serif", position: "relative", boxShadow: `0 24px 70px rgba(0,0,0,0.7), 0 0 40px ${GOLD}14` }}>
        <button type="button" onClick={() => dismiss(false)} aria-label="Close" style={{ position: "absolute", top: 12, right: 12, background: "transparent", border: "none", color: "rgba(255,255,255,0.55)", cursor: "pointer", padding: 6, display: "flex" }}><X size={16}/></button>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 10, fontWeight: 800, letterSpacing: 1.6, textTransform: "uppercase", color: GOLD, marginBottom: 10 }}><Flame size={12}/> New</div>
        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 38, letterSpacing: 1.5, lineHeight: 1, marginBottom: 12 }}>Set of the day</div>
        <p style={{ fontSize: 14.5, lineHeight: 1.6, color: "rgba(255,255,255,0.82)", margin: "0 0 10px" }}>
          One set or action every day, pulled from the best of pro and international basketball, with a note on what to watch for. They live in your Playbook, where you can save the ones you'd run and keep your own notes on them.
        </p>
        <p style={{ fontSize: 14.5, lineHeight: 1.6, color: "#F5F5F5", fontWeight: 700, margin: "0 0 20px" }}>Twelve are already there.</p>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button type="button" onClick={() => dismiss(false)} style={{ padding: "10px 16px", borderRadius: 9, border: "1px solid rgba(255,255,255,0.15)", background: "transparent", color: "rgba(255,255,255,0.7)", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Later</button>
          <button type="button" onClick={() => dismiss(true)} style={{ padding: "10px 18px", borderRadius: 9, border: "none", background: `linear-gradient(180deg, ${GOLD}, #d4ce8a)`, color: "#111", fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>Open the Playbook</button>
        </div>
      </div>
    </div>
  );
}

export default SetsLaunchModal;
